
import {
    apiErrorCatch,
    apiRequest,
    apiSign,
    bucket
} from "@/common/http";
import {
    User
} from "@/components/cigo-admin-core/utils/types";
import cigoLayer from "@/components/cigo-layer";
import CigoAvatar from "@/components/cigo-ui/unit/form/uploader/cigo-avatar.vue";
import {
    useForm
} from "@ant-design-vue/use";
import {
    toArray
} from "lodash";
import {
    defineComponent,
    onBeforeMount,
    reactive,
    ref,
    toRaw,
    toRef,
    watch
} from "vue";
import {
    CigoAdminStore
} from "@/components/cigo-admin-core/store";

export default defineComponent({
    name: "CigoProfile",
    components: {
        CigoAvatar
    },
    props: {
        layerData: {
            type: Object,
            default: {}
        }
    },
    setup(props, ctx) {
        let userInfo = toRef(CigoAdminStore.getState(), 'userInfo');
        let groupList: any = ref([]);

        onBeforeMount(() => {
            requestGroupList();
        });

        const requestGroupList = () => {
            let params = {
                status: "1"
            };
            apiRequest.v1
                .post("/groupList", params, {
                    headers: apiSign(params)
                })
                .then(response => {
                    //更新本地角色分组数据
                    groupList.value = [...response.data.data];
                })
                .catch(apiErrorCatch.v1);
        };

        let formDataRef = reactive({
            id: userInfo.value.id,
            img: userInfo.value.img,
            img_info: userInfo.value.img_info ?
                userInfo.value.img_info : {
                    id: 0
                }, //Tips_Flag 前端识别undefined
            role_flag: userInfo.value.role_flag,
            username: userInfo.value.username,
            nickname: userInfo.value.nickname,
            password: '',
            email: userInfo.value.email,
            auth_group: userInfo.value.auth_group
        });
        const formItemRules = reactive({
            password: [{
                    required: true,
                    message: "请设置密码"
                },
                {
                    max: 20,
                    message: "密码最多20个字符"
                },
                {
                    min: 6,
                    message: "密码最少6个字符"
                }
            ],
            email: [{
                type: "email",
                message: "邮箱格式错误"
            }]
        });
        const {
            resetFields,
            validate,
            validateInfos,
            mergeValidateInfo
        } = useForm(formDataRef, formItemRules);

        const updateAvatarInfo = (avatarInfo: any) => {
            formDataRef.img = avatarInfo.id;
            formDataRef.img_info = avatarInfo;
        };

        const doSubmit = (e: any) => {
            e.preventDefault();
            validate()
                .then(() => {
                    let params: any = {};
                    Object.assign(params, toRaw(formDataRef));
                    delete params.img_info;
                    apiRequest.v1
                        .post(
                            "/edit/Manager",
                            params, {
                                headers: apiSign(params)
                            }
                        )
                        .then(response => {
                            let userInfoTmp: User = response.data.data;
                            userInfoTmp.isLogin = true;
                            userInfo.value = userInfoTmp;
                            CigoAdminStore.saveUserInfo(userInfoTmp);

                            //提示及关闭窗口
                            cigoLayer.msg(response.data.msg);
                            ctx.emit("close");
                        })
                        .catch(apiErrorCatch.v1);
                })
                .catch(err => {
                    console.log("error", err);
                });
        };

        const cancel = () => {
            ctx.emit("close");
        };

        return {
            labelCol: {
                span: 4
            },
            wrapperCol: {
                span: 19
            },
            validateInfos,
            groupList,
            formDataRef,
            updateAvatarInfo,
            doSubmit,
            cancel
        };
    }
});
